module.exports = __webpack_public_path__ + "img/sofa-leather.bb7a5b67.png";